<template>
  <q-icon :size="size">
    <svg
      version="1.1" id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 32 32" enable-background="new 0 0 32 32"
      xml:space="preserve"
    >
      <g>
        <polygon points="16,23.9 2.3,10.2 3.7,8.8 16,21.1 28.3,8.8 29.7,10.2 	" />
      </g>
    </svg>
  </q-icon>
</template>

<script>
export default {
  name: 'ChevronDownIcon',
  props: {
    size: {
      type: String,
      default: '16px'
    }
  }
}
</script>

<style scoped>

</style>
